import React, { Component } from "react";

class DashboardKPICards extends Component {
    formatRate(count, total) {
        if (total <= 0) return "0%";
        return ((count / total) * 100).toFixed(1) + "%";
    }

    render() {
        const {
            monthlyLeadCount,
            monthlyConvertedLeadCount,
            yearlyLeadCount,
            yearlyConvertedLeadCount,
        } = this.props;

        const monthlyConversionRate =
            monthlyLeadCount > 0
                ? (monthlyConvertedLeadCount / monthlyLeadCount) * 100
                : 0;
        const yearlyConversionRate =
            yearlyLeadCount > 0
                ? (yearlyConvertedLeadCount / yearlyLeadCount) * 100
                : 0;

        return (
            <>
                <div className="row">
                    <div className="col-xl-2 col-md-6 mb-4">
                        <div className="card border-left-primary shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                            Lead (Monthly)
                                        </div>
                                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                                            {monthlyLeadCount}
                                        </div>
                                        <div className="text-xs text-muted mt-1">
                                            Conversion: {this.formatRate(monthlyConvertedLeadCount, monthlyLeadCount)}
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="fas fa-calendar fa-2x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-2 col-md-6 mb-4">
                        <div className="card border-left-success shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                            Converted Lead (Monthly)
                                        </div>
                                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                                            {monthlyConvertedLeadCount}
                                        </div>
                                        <div className="text-xs text-muted mt-1">
                                            Of {monthlyLeadCount} monthly leads
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="fas fa-check-circle fa-2x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-2 col-md-6 mb-4">
                        <div className="card border-left-info shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                            Lead (Yearly)
                                        </div>
                                        <div className="row no-gutters align-items-center">
                                            <div className="col-auto">
                                                <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                                                    {yearlyLeadCount}
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="progress progress-sm mr-2">
                                                    <div
                                                        className="progress-bar bg-info"
                                                        role="progressbar"
                                                        style={{ width: yearlyConversionRate + "%" }}
                                                        aria-valuenow={yearlyConversionRate}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-xs text-muted mt-1">
                                            Conversion: {this.formatRate(yearlyConvertedLeadCount, yearlyLeadCount)}
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="fas fa-clipboard-list fa-2x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-2 col-md-6 mb-4">
                        <div className="card border-left-warning shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                            Converted Lead (Yearly)
                                        </div>
                                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                                            {yearlyConvertedLeadCount}
                                        </div>
                                        <div className="text-xs text-muted mt-1">
                                            Of {yearlyLeadCount} yearly leads
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="fas fa-trophy fa-2x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-2 col-md-6 mb-4">
                        <div className="card border-left-success shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                            Monthly Conversion Rate
                                        </div>
                                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                                            {monthlyConversionRate.toFixed(1)}%
                                        </div>
                                        <div className="row no-gutters align-items-center mt-2">
                                            <div className="col">
                                                <div className="progress progress-sm mr-2">
                                                    <div
                                                        className="progress-bar bg-success"
                                                        role="progressbar"
                                                        style={{ width: monthlyConversionRate + "%" }}
                                                        aria-valuenow={monthlyConversionRate}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="fas fa-percentage fa-2x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-2 col-md-6 mb-4">
                        <div className="card border-left-info shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                            Yearly Conversion Rate
                                        </div>
                                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                                            {yearlyConversionRate.toFixed(1)}%
                                        </div>
                                        <div className="row no-gutters align-items-center mt-2">
                                            <div className="col">
                                                <div className="progress progress-sm mr-2">
                                                    <div
                                                        className="progress-bar bg-info"
                                                        role="progressbar"
                                                        style={{ width: yearlyConversionRate + "%" }}
                                                        aria-valuenow={yearlyConversionRate}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="fas fa-chart-line fa-2x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default DashboardKPICards;
